import {usePromotion} from '@/context/Promotion/PromotionContext'
import {PointsReward, PromotionCondition, RewardType} from '@/types/promotion'
import {toRewardsUpdate} from './toRewardsUpdate'
import {useRewardValidations} from './RewardValidations.js'

type UseRewardPointsArgs = {
  promotionCondition: PromotionCondition
  rewardIndex?: number
}

export const useRewardPoints = ({promotionCondition, rewardIndex = 0}: UseRewardPointsArgs) => {
  const {updateCondition} = usePromotion()
  const {hasValueLayerError} = useRewardValidations(promotionCondition, rewardIndex)
  const points = (promotionCondition?.rewards?.[rewardIndex] as PointsReward)?.points || ''

  const updatePoints = (value: number | string) => {
    updateCondition({
      sequence: promotionCondition.sequence,
      rewards: toRewardsUpdate({type: RewardType.POINTS, points: Number(value)}, rewardIndex),
    })
  }

  // Only whole numbers are accepted; anything else is reverted to the previous points value
  const handlePointsChange = (value: string) => {
    const isValid = /^-?\d+$/.test(value) || value === ''
    const newValue = isValid ? value : points
    // Peacock TextInput doesn't re-render when given the same value, so push the raw value first, then the valid one
    updatePoints(value)
    setTimeout(() => {
      updatePoints(newValue)
    }, 0)
  }

  return {
    pointsValue: !Number.isNaN(points) ? points.toString() : '',
    isError: hasValueLayerError(),
    handlePointsChange,
  }
}
